var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9983 5.29503L12.9983 1.77735M12.9983 1.77735H9.48066M12.9983 1.77735L7.72183 7.05386M6.54927 1.77734H5.25946C4.27441 1.77734 3.78189 1.77734 3.40566 1.96905C3.07471 2.13767 2.80564 2.40674 2.63701 2.73769C2.44531 3.11392 2.44531 3.60644 2.44531 4.59149V9.51624C2.44531 10.5013 2.44531 10.9938 2.63701 11.37C2.80564 11.701 3.07471 11.9701 3.40566 12.1387C3.78189 12.3304 4.27441 12.3304 5.25946 12.3304H10.1842C11.1692 12.3304 11.6618 12.3304 12.038 12.1387C12.369 11.9701 12.638 11.701 12.8066 11.37C12.9983 10.9938 12.9983 10.5013 12.9983 9.51624V8.22642",
    stroke: "#4B4AD5",
    strokeWidth: 1.17256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLocation);
export default __webpack_public_path__ + "static/media/google-location.bc540df5a4147f3c6b19f33d5deff5c8.svg";
export { ForwardRef as ReactComponent };